import { render, staticRenderFns } from "./bannerB.vue?vue&type=template&id=0835e957"
import script from "./bannerB.vue?vue&type=script&lang=js"
export * from "./bannerB.vue?vue&type=script&lang=js"
import style0 from "./bannerB.vue?vue&type=style&index=0&id=0835e957&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports